import { AUTO_REPLY_STATUS, AutoReplyPopConfirmReason, AutoReplyStatus } from './types';

const AUTO_REPLY_ACTIVE_STATUSES = ['send', 'defer'];

/**
 * Check if the auto reply is paused
 * @param replyRecommendation - The reply recommendation
 * @returns True if the auto reply is paused, false otherwise
 */
export function isAutoReplyPaused(
    isAutoReplyEnabled: boolean,
    isReceivedMessage: boolean,
    autoReplyStatus: AutoReplyStatus = AUTO_REPLY_STATUS.SKIP
) {
    if (isAutoReplyEnabled === false) {
        return true;
    }

    if (isReceivedMessage) {
        return !AUTO_REPLY_ACTIVE_STATUSES.includes(autoReplyStatus);
    }

    return false;
}

/**
 * Get the message to display when auto reply requires a popconfirm
 * @param requirePopconfirmReason - The reason for requiring a popconfirm
 * @returns The message to display
 */
export function getAutoReplyAlertMessage(
    requirePopconfirmReason?: AutoReplyPopConfirmReason
): string | undefined {
    switch (requirePopconfirmReason) {
        case 'old-message':
            return 'Auto Reply is unavailable for messages received before June 2025. Send a message first to turn on future AI replies.';
        case 'disabled-when-received':
            return 'Message received while auto reply was disabled. Send a message first to turn on future AI replies.';
        default:
            return undefined;
    }
}
